<template>
    <transition name="fade">
        <FileModal v-if="modal" @changeVisibility="modal = false"/>
    </transition>
    <transition name="fade">
        <ConfirmacaoModal v-if="cModal" @changeVisibility="cModal = false" @changeAndReload="cModal = false; filter()" :loja="lojaConfirmacao" type="adesao"/>
    </transition>
    <transition name="fade">
        <PesquisadorModal v-if="pmodal" @changeVisibility="pmodal = false" @close="closePModal()" :cnpjs="cnpjs" type="adesao"/>
    </transition>
  <section id="lojas" ref="testeDiv" class="w-full px-8 m-auto py-8 h-full">
    <div class="w-full flex mb-4 justify-between">
        <p class="dark:text-gray-200 text-gray-700 text-2xl tracking-widest uppercase">Lista de Adesão</p>
        <div v-if="userRole === 'administrador'" class="flex flex-row flex-wrap">
            <button @click="modal = true" class="bg-indigo-500 hover:bg-indigo-600 transition-colors uppercase text-sm text-gray-50 rounded-l-md pl-2 pr-1">Importar</button>
            <button @click.prevent="create = !create" class="bg-indigo-500 h-full hover:bg-indigo-600 transition-colors uppercase text-sm text-gray-50 rounded-r-md flex items-center">
                <span class="material-icons">
                    keyboard_arrow_down
                </span>
            </button>
            <div class="relative w-full bg-yellow-300 mt-2 flex-wrap">
                <div v-if="create" class="absolute flex h-10 w-48 -left-20 bg-gray-100 dark:bg-gray-700 shadow-lg rounded-lg px-4 text-sm ">
                    <button @click.prevent="redirectNew()" class="text-gray-800 dark:text-gray-200 dark:hover:text-indigo-400 text-center uppercase cursor-pointer transition-all duration-300 hover:text-indigo-600 ">Criar manualmente</button>
                </div>
            </div>
        </div>
    </div>
    <div class="w-full flex mb-1 justify-between gap-x-4">
        <span class="text-gray-200 text-3xl uppercase w-1/4"> </span>
        <div class="flex-1 px-5 flex flex-row items-center gap-x-2" v-if="userRole === 'administrador'">
            <span @click="selectAll()"  :class="selected.length ? 'dark:text-indigo-400 text-indigo-600' : 'text-gray-500' " class="h-6 w-6 rounded-full transition-colors duration-300 select-none cursor-pointer">
                <span v-if="selected.length == 0" class="material-icons">
                    radio_button_unchecked
                </span>
                <span v-else class="material-icons-outlined">
                    check_circle
                </span>
            </span>
            <p class="dark:text-gray-200 text-gray-700">{{`${!selected.length ? 'Selecionar todos' : selected.length + ` loja${selected.length > 1 ? 's' : ''} selecionada${selected.length > 1 ? 's' : ''} —`}`}}</p>
            <button v-if="selected.length > 0" @click="configPModal()" class="text-indigo-600 dark:text-indigo-400">Adicionar pesquisador para as lojas selecionadas</button>
        </div>
    </div>
    <div class="flex flex-row gap-x-4 w-full">
        <div class="pt-2 w-1/4 flex-none h-40 sticky rounded-lg">
            <div class="w-4/5 m-auto py-4 flex flex-col gap-y-4">
                <p class="text-2xl dark:text-gray-300 text-gray-700">Filtros</p>
                <Input label="CNPJ" type="text" v-debounce:300="filter" v-model="cnpjSearch" v-maska="'##.###.###/####-##'"/>
                <Input label="Razão Social" type="text" v-debounce:300="filter" v-model="razaoSearch"/>
                <Input label="Nome Fantasia" type="text" v-debounce:300="filter" v-model="nomeSearch"/>
                <br>
                <Select label="Segmento" placeholder="Selecionar segmento" :list="listSegmentos" v-model="segmentoSearch" @filter="filter()" desc="descricao"/>
                <Select label="Status" placeholder="Selecionar status" :list="listStatus" v-model="statusSearch" @filter="filter()" desc="descricao"/>
                <Select label="Região" placeholder="Selecionar região" :list="listRegioes" v-model="regiaoSearch" @filter="filter()" desc="descricao"/>
                <Select label="Faturamento" placeholder="Selecionar faturamento" :list="listFaturamentos" v-model="faturamentoSearch" @filter="filter()" desc="descricao"/>
            </div>
        </div>
        <div id="lojas-section" class="w-3/4 flex-none flex flex-col flex-wrap gap-y-4">
            <Skeleton v-if="loading" :pageSize="10"/>
            <div v-else-if="lojas.length == 0 && !loading" class="dark:text-gray-400 text-gray-500 dark:bg-gray-800 bg-gray-200 w-full h-24 rounded-lg flex flex-col items-center justify-center py-2 px-5">
                <p class="text-lg">Nenhum resultado encontrado para essa pesquisa</p>
            </div>
            <span v-for="loja in lojas" :key="`lojas-${loja.id}`" class="w-full">
                <div class=" dark:bg-gray-800 bg-gray-100 border border-gray-200 dark:border-gray-700 w-full h-50 rounded-lg flex flex-row py-2 gap-x-8 px-5">
                    <div class="flex items-center w-6" v-if="userRole === 'administrador'">
                        <div @click="select(loja.cnpj)" :class="selected.includes(loja.cnpj) ? 'dark:text-indigo-400 text-indigo-600' : 'text-gray-500' " class="h-6 w-6 rounded-full transition-colors duration-300 select-none cursor-pointer">
                            <span v-if="!selected.includes(loja.cnpj)" class="material-icons">
                                radio_button_unchecked
                            </span>
                            <span v-else class="material-icons-outlined">
                                check_circle
                            </span>
                        </div>
                    </div>
                    <div class="flex flex-col content-around h-full w-1/2">
                        <div><p class="text-lg dark:text-indigo-400 text-indigo-600 truncate">{{loja.razao_social}}</p></div>
                        <div><p class="text dark:text-indigo-200 text-indigo-400">{{loja.nome_fantasia}}</p></div>
                        <div><p class="text-sm dark:text-gray-200 text-gray-600">{{cnpjMask(loja.cnpj)}}</p></div>
                        <div><p class="text-sm dark:text-gray-200 text-gray-600 font-bold">{{loja.segmento}}</p></div>
                        <div><p :class="getStatusColor(loja.status.id)" class="text-sm text-gray-600 font-bold">{{loja.status.descricao}}</p></div>
                        <div class="mt-2">
                            <p class="dark:text-gray-300 text-gray-500 text-sm">{{phoneMask(loja.telefone1) ? phoneMask(loja.telefone1) :  phoneMask(loja.telefone2) ? phoneMask(loja.telefone1) : 'Não há telefones cadastrados'}} - {{loja.nome_contato ? loja.nome_contato : 'Sem informação de contato'}}</p>
                            <p class="dark:text-gray-300 text-gray-500 text-sm">{{loja.email}}</p>
                        </div>
                        <div class="mt-4 flex flex-row items-center text-gray-500 dark:text-gray-400">
                            <span class="material-icons md-12">location_on</span>
                            <p class="uppercase text-xs break-words">{{loja.endereco.endereco}}, {{loja.endereco.numero}}, {{loja.endereco.bairro}} - {{loja.endereco.cidade}} - {{loja.endereco.estado}}</p>
                        </div>
                    </div>
                    <div class="w-1/4 justify-center self-center">
                        <div class="flex flex-col gap-y-2">
                            <div>
                                <p class="text-center text-sm dark:text-gray-500 text-gray-600 uppercase">Região</p>
                                <p class="text-center text dark:text-indigo-200 text-indigo-600">{{loja.endereco.regiao}}</p>
                            </div>
                            <div>
                                <p class="text-center text-sm dark:text-gray-500 text-gray-600 uppercase">Faturamento</p>
                                <p class="text-center text dark:text-indigo-200 text-indigo-600">{{loja.faturamento}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="w-1/5 justify-center self-center flex flex-col gap-y-2 items-center">
                        <p class="dark:text-gray-500 text-gray-600">PESQUISADOR</p>
                        <div v-if="loja.pesquisador" class="w-16 h-16 bg-indigo-300 rounded-full">
                            <img v-if="loja.pesquisador_avatar" class="rounded-full " :src="loja.pesquisador_avatar" alt="">
                            <span v-else class="h-full w-full flex text-gray-100"><p class="m-auto text-3xl">{{loja.pesquisador[0]}}{{loja.pesquisador.split(' ')[1][0]}}</p></span>
                        </div>
                        <span @click="configPModal(loja.cnpj)" v-else class="material-icons-outlined text-6xl text-indigo-400 dark:text-indigo-200 cursor-pointer">
                            person_add
                        </span>
                        <p class="dark:text-gray-200 text-gray-600 text-center">{{loja.pesquisador ? loja.pesquisador : 'Nenhum pesquisador selecionado'}}</p>
                    </div>
                    <div class="flex-1 flex flex-col gap-y-5 w-6 my-auto">
                        <span @click="openConfirmacao(loja.cnpj)" class=" material-icons-outlined self-center text-3xl hover:text-indigo-400 text-gray-400 dark:text-gray-500 rounded-full transition-colors duration-300 select-none cursor-pointer">
                            content_paste
                        </span>
                        <span @click="click2dial(phoneMask(loja.telefone1), phoneMask(loja.telefone2), loja.cnpj)" v-if="phoneMask(loja.telefone1) || phoneMask(loja.telefone2)" class="h-1/2 material-icons text-3xl hover:text-indigo-400 text-gray-400 dark:text-gray-500 rounded-full transition-colors duration-300 select-none cursor-pointer">
                            {{calling.status && calling.lojaId === loja.cnpj ? 'phone_in_talk' : 'phone'}}
                        </span>
                    </div>
                </div>
            </span>
        </div>
    </div>
    <div class="w-full flex mb-1 justify-between gap-x-4">
        <p class="text-gray-200 text-3xl uppercase w-1/4"> </p>
        <div class="flex-1 px-5 flex flex-row items-center gap-x-2">
            <Paginator :data="paginationData" type="page" @changePage="changePage" @changePageSize="changePageSize"/>
        </div>
    </div>
  </section>
</template>
<script>
import { GET_LOJAS_ADESAO, GET_LOJAS_ADESAO_FILTER, GET_REGULAMENTACOES, GET_REGIOES, GET_FATURAMENTOS, GET_SEGMENTOS, GET_STATUS_CONTATO_ADESAO, REQUEST_CALL } from '../../mixins/api.js'
import { telephoneMask, cnpjMask as cnpj_mask } from '../../mixins/mask.js'
import { onMounted, reactive, ref } from 'vue'
import axios from 'axios'
import FileModal from './FileModal.vue'
import PesquisadorModal from './PesquisadorModal.vue'
import ConfirmacaoModal from './ConfirmacaoModal.vue'
import Input from '@/components/Design/Input'
import Select from '@/components/Design/Select'
import Paginator from '@/components/Design/Pagination'
import Skeleton from './LojaSkeleton.vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { getStatusColor as getColor } from '../../mixins/colors'
import { displayNotification } from '../../mixins/notification.js'
export default {
    name: 'Lojas',
    components: {
        Input,
        Skeleton,
        Paginator,
        Select,
        FileModal,
        PesquisadorModal,
        ConfirmacaoModal
    },
    setup () {
        const phoneMask = telephoneMask
        const cnpjMask = cnpj_mask
        const store = useStore()
        const router = useRouter()

        const userRole = store.getters['auth/user'].role

        // Select items
        const selected = ref([])
        const select = (cnpj) => {
            if (selected.value.includes(cnpj)) {
                var index = selected.value.indexOf(cnpj)
                if (index !== -1) {
                    selected.value.splice(index, 1)
                }
            } else {
                selected.value.push(cnpj)
            }
        }
        const selectAll = () => {
            if (selected.value.length != lojas.value.length) {
                for (const l in lojas.value) {
                    if (!selected.value.includes(lojas.value[l].cnpj)) { selected.value.push(lojas.value[l].cnpj) }
                }
            } else {
                while (selected.value.length > 0) {
                    selected.value.pop()
                }
            }
        }

        const lojas = ref([])
        const loading = ref(true)
        onMounted(async () => {
            await GET_LOJAS_ADESAO(10).then(response => {
                persistFilter.value = response.config.url
                lojas.value = response.data.data
                loading.value = false
                paginationData.value = response.data.meta
                paginationData.value.meta = paginationData.value.meta.replace('http://localhost:8000', '')
            }).catch(() => {
            })
        })

        const paginationData = ref({})
        const paginationRequest = async (url) => {
            loading.value = true
            await axios.get(url).then(response => {
                lojas.value = response.data.data
                loading.value = false
                paginationData.value = response.data.meta
            })
            var element = document.getElementById('lojas-section')
            var top = element.offsetTop
            window.scrollTo(0, top)
        }

        const listSegmentos = ref([])
        const listStatus = ref([])
        const listRegioes = ref([])
        const listFaturamentos = ref([])
        const getLists = async () => {
            await GET_STATUS_CONTATO_ADESAO().then(r => {
                listStatus.value = r.data
                listStatus.value = listStatus.value.filter(s => s.descricao.toLowerCase() !== 'mudança segmento')
            })
            await GET_REGIOES().then(r => {
                listRegioes.value = r.data
            })
            await GET_FATURAMENTOS().then(r => {
                listFaturamentos.value = r.data
            })
            await GET_SEGMENTOS().then(r => {
                listSegmentos.value = r.data
            })
        }
        getLists()

        const cnpjSearch = ref('')
        const razaoSearch = ref('')
        const nomeSearch = ref('')
        const segmentoSearch = ref('')
        const statusSearch = ref('')
        const regiaoSearch = ref('')
        const faturamentoSearch = ref('')

        const persistFilter = ref('')
        const pageSize = ref(10)
        const filter = async (_, e, page) => {
            const filters = {
                cnpj: cnpjSearch.value.replaceAll('.', '').replaceAll('/', '').replaceAll('-', ''),
                razao: razaoSearch.value,
                nome: nomeSearch.value,
                segmento: segmentoSearch.value ? listSegmentos.value.filter(x => x.descricao === segmentoSearch.value)[0].id : '',
                status: statusSearch.value ? listStatus.value.filter(x => x.descricao === statusSearch.value)[0].id : '',
                regiao: regiaoSearch.value ? listRegioes.value.filter(x => x.descricao === regiaoSearch.value)[0].id : '',
                faturamento: faturamentoSearch.value ? listFaturamentos.value.filter(x => x.descricao === faturamentoSearch.value)[0].id : '',
                page: page
            }
            await GET_LOJAS_ADESAO_FILTER(pageSize.value, filters).then(response => {
                persistFilter.value = response.config.url
                lojas.value = response.data.data
                loading.value = false
                paginationData.value = response.data.meta
            }).catch(() => {
            })
        }
        const changePage = (page) => {
            filter(null, null, page)
            scrollTop()
        }

        const changePageSize = (size) => {
            pageSize.value = size
            filter()
        }

        const testeDiv = ref(null)

        const modal = ref(false)
        const showModal = () => {
            modal.value = false
        }
        const pmodal = ref(false)
        const cnpjs = ref([])
        const configPModal = (cnpj) => {
            if (cnpj) {
                cnpjs.value = [cnpj]
            } else {
                cnpjs.value = selected.value
            }
            pmodal.value = true
        }
        const closePModal = () => {
            cnpjs.value = []
            selected.value = []
            pmodal.value = false
            filter(null, null, paginationData.value.current_page)
        }

        const lojaConfirmacao = ref({})
        const cModal = ref(false)
        const openConfirmacao = (cnpj) => {
            cModal.value = true
            lojaConfirmacao.value = lojas.value.filter(x => x.cnpj === cnpj)[0]
        }

        const create = ref(false)

        const redirectNew = () => {
            router.push('/dashboard/lojas/nova')
        }

        const scrollTop = () => {
            var element = document.getElementById('screen')
            element.scrollTo({ top: 0, behavior: 'smooth' })
        }

        const getStatusColor = getColor

        const calling = reactive({
            lojaId: 0,
            status: false
        })
        const click2dial = (phone1, phone2, lojaId) => {
            if (calling.status) {
                return
            }
            calling.lojaId = lojaId
            calling.status = true

            let callingPhone = ''
            if (phone1) {
                callingPhone = phone1.replace('(', '').replace(')', '').replace('-', '').replaceAll(' ', '')
            } else if (phone2) {
                callingPhone = phone2.replace('(', '').replace(')', '').replace('-', '').replaceAll(' ', '')
            }
            REQUEST_CALL(callingPhone).then(r => {
                displayNotification(r)
            }).catch(e => {
                displayNotification(e.response)
            }).finally(() => {
                calling.status = false
            })
            openConfirmacao(lojaId)
        }

        return {
            lojas,
            selected,
            loading,
            paginationData,
            testeDiv,
            userRole,

            cnpjSearch,
            razaoSearch,
            nomeSearch,
            segmentoSearch,
            statusSearch,
            regiaoSearch,
            faturamentoSearch,
            listSegmentos,
            listStatus,
            listRegioes,
            listFaturamentos,

            create,

            persistFilter,

            lojaConfirmacao,
            cModal,
            modal,
            pmodal,
            cnpjs,

            // Functions
            showModal,
            paginationRequest,
            select,
            selectAll,
            phoneMask,
            cnpjMask,
            filter,
            configPModal,
            closePModal,
            openConfirmacao,
            redirectNew,
            changePageSize,
            changePage,
            scrollTop,
            getStatusColor,
            click2dial,
            calling

        }
    }
}
</script>
